import * as yup from 'yup';
import ITHomeDelivery from '../../interfaces/deliverytime/deliverytime';

export const deliverytimeInitialValues: ITHomeDelivery = {
	deliveryType: '',
	country: {
		label: 'Veldu land',
		value: '',
	},
};

export const deliverytimeSchema = yup.object().shape({
	deliveryType: yup.string().required('deliveryTypeRequired'),
	country: yup.string().required('countryRequired'),
});
